import { render, staticRenderFns } from "./formularioDespacho.vue?vue&type=template&id=2ab91558"
import script from "./formularioDespacho.vue?vue&type=script&lang=js"
export * from "./formularioDespacho.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports